import * as z from 'zod'
import { TaxSystemEnum } from '~/shared/config/enums'
import { enumOptionSchema, innRequiredSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const schema = z.object({
  email: z.string().email('Неверный формат email'),
  inn: innRequiredSchema,
  taxSystem: enumOptionSchema(TaxSystemEnum),
})

export type DriverCreateIndividualEntrepreneurEventAttributes = z.infer<
  typeof schema
>

export class DriverCreateIndividualEntrepreneurEvent extends ApiModel<
  typeof schema,
  DriverCreateIndividualEntrepreneurEventAttributes
> {
  static jsonApiType = 'driver-create-individual-entrepreneur-events'

  static schema = schema
}
